import {
  ContextualMenu,
  DirectionalHint,
  IContextualMenuProps,
  IconButton,
} from "@fluentui/react";
import { useDeleteCollection } from "components/management/collection/hooks";
import { useState } from "react";
import { useCallback } from "react";
import { useRef } from "react";
import { IStacCollection } from "types/stac";

interface CollectionActionsProps {
  collection: IStacCollection;
  onEdit: (collection: IStacCollection) => void;
}

export const CollectionActions = ({
  collection,
  onEdit,
}: CollectionActionsProps) => {
  const linkRef = useRef(null);
  const [showContextualMenu, setShowContextualMenu] = useState(false);

  const { deleteDialog, showDeleteDialog, setShowDeleteDialog } =
    useDeleteCollection(collection);

  const handleContextualMenu = useCallback(
    (ev: React.MouseEvent<HTMLElement>) => {
      if (showContextualMenu) {
        setShowContextualMenu(false);
      }
      setShowContextualMenu(true);
    },
    [showContextualMenu]
  );

  const onHideContextualMenu = useCallback(() => {
    setShowContextualMenu(false);
  }, []);

  const handleClick = useCallback(
    (ev, menuItem) => {
      if (menuItem.key === "delete") {
        setShowDeleteDialog(true);
      } else if (menuItem.key === "edit") {
        onEdit(collection);
      }
      onHideContextualMenu();
    },
    [onHideContextualMenu, setShowDeleteDialog, onEdit, collection]
  );

  return (
    <div ref={linkRef}>
      <IconButton
        iconProps={{ iconName: "more" }}
        title={"Actions"}
        ariaLabel="Collection Actions"
        onClick={handleContextualMenu}
      />
      <ContextualMenu
        items={overflowProps.items}
        hidden={!showContextualMenu}
        target={linkRef}
        onItemClick={handleClick}
        onDismiss={onHideContextualMenu}
        directionalHint={DirectionalHint.rightTopEdge}
        isBeakVisible={false}
      />
      {showDeleteDialog && deleteDialog}
    </div>
  );
};

const overflowProps: IContextualMenuProps = {
  items: [
    {
      key: "edit",
      text: "Edit",
      iconProps: { iconName: "Edit" },
      ariaLabel: "Edit collection",
    },
    {
      key: "delete",
      text: "Delete",
      iconProps: { iconName: "Delete" },
      ariaLabel: "Delete collection",
    },
  ],
};
